import { defaultPromoCards } from "@loot-os/api-contract";
import type { PromoCardsContent } from "@loot-os/design-system/templates/home/homeContent";
import { useTenant } from "../../../../lib/tenant.js";
import { useTerminology } from "../../../../lib/terminology.js";

/**
 * Card-wide links to the games the store has on, then the fairness page (`defaultPromoCards`
 * decides which and words them).
 */
export function usePromoCardsContent(): PromoCardsContent {
  const { hasFeature } = useTenant();
  return {
    cards: defaultPromoCards(useTerminology(), hasFeature).map(({ key, eyebrow, title, href }) => ({
      kind: "link",
      key,
      eyebrow,
      title,
      destination: { href },
    })),
  };
}
